<div class="wrapper">
  <div class="container px-0">
      <!--<h5 class="main-title">{{patientpersonalinfo.PracticeName || 'N/A'}}</h5>-->
      
    <div class=" pb-2 fw-bold">
      <h5 class="title fw-bold text-center mb-2 mt-2 fw-bold">{{'updateinfo.has_your_information_changed'|translate}}</h5>
    </div>
      <div class=" pt-1 pb-2">
        <div class="form-row">
          <div class=" col-md-4 col-lg-3 pb-2">
            <div class="form-group mb-2 border-bottom">
              <label class="form-label fw-bold"> {{'updateinfo.full_name'|translate}}</label>
              <input type="text" disabled placeholder="{{'updateinfo.full_name'|translate}}"
                     [value]="(patientpersonalinfo.FIRSTNAME + ' ' + patientpersonalinfo.LASTNAME) | titlecase" class="form-control text-capitalize border-0">

            </div>
          </div>

          <div class="col-md-4 col-lg-3 pb-2">
            <div class="form-group form-select mb-2 border-bottom">
              <label class="form-label padding-left fw-bold">{{'updateinfo.gender'|translate}}<span class="text-danger">*</span></label>
              <select class="form-control text-capitalize border-0" (change)="onFocusOutGender($event.target)"
                      [(ngModel)]="Updatepersonalinfo.GENDER">
                <option value="" disabled>{{'RegistrationPage.gender.placeholder' | translate}}</option>
                <option value="male">{{'RegistrationPage.gender.male' | translate}}</option>
                <option value="female">{{'RegistrationPage.gender.female' | translate}}</option>
                <option value="unknown">{{'RegistrationPage.gender.unknown' | translate}}</option>
              </select>
            </div>
            <div class="mb-2">
              <span class="err" *ngIf="!isGenderSelected"> {{'RegistrationPage.gender.error' | translate}}</span>
            </div>
          </div>
          <!--<div class="col-3 col-md-4 col-lg-3 pb-2">
    <div class="form-group mb-2 border-bottom">
      <label class="form-label padding-left fw-bold"> {{'updateinfo.gender'|translate}}</label>
      <input type="text" disabled  placeholder="{{('updateinfo.gender' | translate) | titlecase}}" [value]="Updatepersonalinfo.GENDER" class="form-control border-0">
    </div>
  </div>-->
          <!--<div class="col-md-3 col-lg-3 pb-2">
    <div class="form-group form-select mb-2 border-bottom">
      <label class="form-label padding-left fw-bold"> Preferred Contact Method<span class="text-danger">*</span></label>
      <select class="form-control text-capitalize border-0" >
        <option value="email" >
          Email
        </option>
        <option value="text">
          Text
        </option>
        <option  value="both">
          Both
        </option>
      </select>

    </div>
  </div>-->

          <div class="col-md-4 col-lg-3 pb-2">
            <div class="form-group mb-2 border-bottom ">
              <label class="form-label padding-left fw-bold"> {{'updateinfo.email'|translate}}</label>
              <input type="text" class="form-control border-0 ltr-component" [(ngModel)]="Updatepersonalinfo.EMAIL_ADDRESS" placeholder="{{'updateinfo.email_placeholder'|translate}}" (keypress)="valEmailSearchAdd($event)">
            </div>
            <div>
              <span class="err" *ngIf="emError1">{{'updateinfo.valid_email'|translate}}</span>
              <!--<span class="text-primary fs-12">{{'updateinfo.email_only_your_provider_can_update_email'|translate}}</span>-->
            </div>

          </div>
          <div class="col-md-4 col-lg-3 pb-2">
            <div class="form-group mb-2 border-bottom ">
              <label class="form-label padding-left fw-bold"> {{'updateinfo.cellphone'|translate}}<span class="text-danger">*</span></label>
              <input type="text" class="form-control border-0 ltr-component" [(ngModel)]="Updatepersonalinfo.CELL_PHONE"
                     (input)="validatePhoneNo($event.target);validatePhone($any($event.target).value ,'cell')" maxlength="14"
                     placeholder="{{'updateinfo.cellphone_placeholder'|translate}}">
            </div>
            <span class="err" *ngIf="!isValidCellPhone">{{'updateinfo.homephone_phone_number_should_be_minimum_10_digits'|translate}}</span>
            <span class="err" *ngIf="iscellphone">
              {{'updateinfo.cellphone_error'|translate}}
            </span>
            <!--<span class="text-primary fs-12">{{'updateinfo.cellphone_only_your_provider_can_update_cell_phone'|translate}}</span>-->
          </div>

          <!-- Smarty APi address Start -->
          <div class="col-md-4 col-lg-6 pb-2">
            <div class="form-group mb-2 border-bottom">
              <label class="form-label padding-left fw-bold"> {{'updateinfo.address'|translate}}<span class="text-danger">*</span></label>
              <div class="dropdown" ngbDropdown #addressDrop="ngbDropdown">
                <input placeholder="{{'updateinfo.address_placeholder'|translate}}" class="form-control text-left text-capitalize border-0 ltr-component" type="text"
                       ngbDropdownAnchor (focus)="addressDrop.open()" id="searchlanguagedropdown" aria-haspopup="true" aria-expanded="false"
                       [(ngModel)]="Updatepersonalinfo.ADDRESS" (input)="ValidateAddress($event.target,'address')"
                       (input)="SearchAdressBySmartyAPi($event)" autocomplete="off">

                <div ngbDropdownMenu class="custom-menu" aria-labelledby="searchaddressdropdown" [ngClass]="{'d-none': dNoneAddress}">
                  <button ngbDropdownItem *ngIf="isLoading">
                    {{'updateinfo.language_loading'|translate}}
                  </button>
                  <!--<button ngbDropdownItem *ngIf="!isLoading && !addressOptions">
            {{'updateinfo.language_search'|translate}}
          </button>-->
                  <button *ngIf="addressOptions?.length == 0 && !isLoading" ngbDropdownItem>
                    {{'updateinfo.language_no_records_found'|translate}}
                  </button>
                  <button ngbDropdownItem *ngFor="let address of addressOptions"
                          (click)="setAddressOption(address)">

                    {{ address.entries && address.entries > 1 ? address.streetLine + ' ' + address.secondary + '... ' +  address.city + ', ' + address.state + ' ' +  address.zipcode + " ( +" + address.entries + " addresses )" : address.streetLine + (address.secondary ? ' ' + address.secondary : '') + ' ' + address.city + ', ' +  address.state + ' ' +  address.zipcode }}

                  </button>
                </div>
              </div>

            </div>
            <div>
              <span class="err" id="c-address-line1-err" *ngIf="addresssline1">
                {{'updateinfo.address_error_message'|translate}}
              </span>
            </div>

          </div>

          <!-- Smarty APi address End -->
          <!--
  <div class="col-md-4 col-lg-6 pb-2">
    <div class="form-group form-floating">

      <input type="text" placeholder="{{'updateinfo.address'|translate}}" [(ngModel)]="Updatepersonalinfo.ADDRESS" class="form-control text-capitalize" maxlength="35"
      autocomplete="off" (input)="ValidateAddress($event.target,'address')">
      <label> {{'updateinfo.address'|translate}} <span class="text-danger">*</span></label>
      <span class="err" id="c-address-line1-err" *ngIf="addresssline1 && Updatepersonalinfo.ADDRESS.length==0">{{'updateinfo.address_error_message'|translate}}</span>
    </div>
  </div> -->
          <div class="col-4 col-md-3 col-lg-3 pb-2">
            <div class="form-group mb-2 border-bottom">
              <label class="form-label padding-left fw-bold"> {{'updateinfo.zip'|translate}}<span class="text-danger">*</span></label>
              <input type="text" placeholder="{{'updateinfo.zip_placeholder'|translate}}" (input)="onFocusOutZIPFinancial($event.target,0)" maxlength="10"
                     autocomplete="off" [(ngModel)]="zipCodeForDisplay" class="form-control border-0 ltr-component">
            </div>
            <div>
              <span class="err" id="f-zip-err" *ngIf="isZipCodeNotValidFinancialInfo">
                {{'updateinfo.enter_valid_zip_code'|translate}}
              </span>
              <span class="err" id="f-zip-err" *ngIf="isZipCode && !isZipCodeNotValidFinancialInfo">
                {{'updateinfo.enter_zip_code'|translate}}
              </span>
            </div>
          </div>
          <div class="col-8 col-md-3 col-lg-3 pb-2">
            <div class="form-group form-select mb-2 border-bottom">
              <label class="form-label padding-left fw-bold"> {{'updateinfo.city'|translate}}<span class="text-danger">*</span></label>
              <select class="form-control text-capitalize border-0" (change)="onFocusOutCity($event.target )"
                      [attr.disabled]="Updatepersonalinfo.CITY ? null : true" [(ngModel)]="Updatepersonalinfo.CITY"
                      [ngModelOptions]="{standalone: true}">

                <option *ngFor="let city of _cityandstate" [value]="city.cityName">
                  {{city.cityName | lowercase}}
                </option>
              </select>

            </div>
          </div>
          <div class="col-4 col-md-3 col-lg-3 pb-2">
            <div class="form-group mb-2 border-bottom">
              <label class="form-label padding-left fw-bold"> {{'updateinfo.state'|translate}}</label>
              <input type="text" [attr.disabled]="true" placeholder="State" [value]="Updatepersonalinfo.STATE" class="form-control border-0">

            </div>
          </div>
          <div class="col-8 col-md-3 col-lg-3 pb-2">
            <div class="form-group  mb-2 border-bottom ">
              <label class="form-label padding-left fw-bold"> {{'updateinfo.language'|translate}}<span class="text-danger">*</span></label>
              <div class="dropdown input-icon search" ngbDropdown #languageDrop="ngbDropdown">
                <input placeholder="{{'updateinfo.language_search'|translate}}" class="form-control text-left text-capitalize border-0 ltr-component" type="text"
                       ngbDropdownAnchor (focus)="languageDrop.open()" id="searchlanguagedropdown" aria-haspopup="true" aria-expanded="false"
                       [(ngModel)]="Updatepersonalinfo.LANGUAGE" (input)="ValidatePersonalInfo($event,'language')"
                       (input)="SearchLanguageList($event)" (blur)="CheckSearchLanguage(Updatepersonalinfo.LANGUAGE)">

                <div ngbDropdownMenu class="custom-menu" aria-labelledby="searchlanguagedropdown" [ngClass]="{'d-none': dNoneLanguage}">
                  <!-- <ul class="list-unstyled symptoms-list mb-0"> -->
                  <button ngbDropdownItem *ngIf="isLoading">
                    {{'updateinfo.language_loading'|translate}}
                  </button>
                  <button ngbDropdownItem *ngIf="!isLoading && !filterSearchLanguageList">
                    {{'updateinfo.language_search'|translate}}
                  </button>
                  <button *ngIf="filterSearchLanguageList?.length == 0 && !isLoading" ngbDropdownItem>
                    {{'updateinfo.language_no_records_found'|translate}}
                  </button>
                  <button ngbDropdownItem *ngFor="let items of filterSearchLanguageList"
                          (click)="SetLanguageList(items.languages)">

                    {{items.languages}}

                  </button>


                  <!-- </ul> -->
                </div>
              </div>

            </div>
            <div>
              <!--<span class="err" *ngIf="isValidLanguage">
        {{'updateinfo.language_enter_valid_language'|translate}}
      </span>-->
              <span class="err" *ngIf="isLanguage">
                {{'updateinfo.language_enterlanguage'|translate}}
              </span>
            </div>
          </div>


          <div *ngIf="!isCellPhoneAvailable" class="col-md-6 col-lg-6 pb-2">
            <div class="form-group mb-2 border-bottom ">
              <label class="form-label padding-left fw-bold"> {{'updateinfo.homephone'|translate}}</label>
              <input type="text" placeholder="{{'updateinfo.homephone_placeholder'|translate}}" class="form-control border-0"
                     (input)="validatePhoneNo($event.target);validatePhone($any($event.target).value ,'phone')" maxlength="14"
                     [(ngModel)]="Updatepersonalinfo.HOME_PHONE">
            </div>
            <div>
              <span class="err" id="c-home-phone-err" *ngIf="!isValidPhone">{{'updateinfo.homephone_phone_number_should_be_minimum_10_digits'|translate}}</span>
            </div>

          </div>
          <div *ngIf="!isCellPhoneAvailable" class="col-md-6 col-lg-6 pb-2">
            <div class="form-group mb-2 border-bottom ">
              <label class="form-label padding-left fw-bold"> {{'updateinfo.workphone'|translate}}</label>
              <input type="text" placeholder="{{'updateinfo.workphone_placeholder'|translate}}" class="form-control border-0"
                     (input)="validatePhoneNo($event.target);validatePhone($any($event.target).value ,'fax')" maxlength="14"
                     [(ngModel)]="Updatepersonalinfo.WORK_PHONE">
            </div>
            <span class="err" id="c-home-phone-err" *ngIf="!isValidFax">{{'updateinfo.workphone_phone_number_should_be_minimum_10_digits'|translate}}</span>
            <!--<span class="fs-12 text-primary" *ngIf="isValidFax">{{'updateinfo.workphone_If_cell_number_is_not_available_add_Home_or_Work_phone'|translate}}</span>-->
          </div>

          <!-- ethnicity and races commented as per CEO suggestion
  <div class="col-md-6 col-lg-6 pb-2">
    <div class="form-group mb-2 border-bottom ">
      <label class="form-label padding-left fw-bold"> {{'updateinfo.ethnicity'|translate}}</label>


      <div class="dropdown input-icon search" ngbDropdown style="flex: 2;" #ethnicityDrop="ngbDropdown">
        <input placeholder="{{'updateinfo.ethnicity_search'|translate}}" class="form-control text-left text-capitalize border-0" type="text"
               ngbDropdownAnchor (focus)="ethnicityDrop.open()" id="searchethnicitydropdown" aria-haspopup="true" aria-expanded="false" [(ngModel)]="enthincitiesSearch"
               (input)="ValidatePersonalInfo($event,'ethn')" (input)="SearchEnthincitiesList($event)">

        <div ngbDropdownMenu class="custom-menu" aria-labelledby="searchlanguagedropdown" [ngClass]="{'d-none': dNoneethnicity}">

          <button ngbDropdownItem *ngIf="isLoading">
            {{'updateinfo.ethnicity_loading'|translate}}
          </button>
          <button ngbDropdownItem *ngIf="!filterSearchEnthincitiesList && !isLoading">
            {{'updateinfo.ethnicity_search'|translate}}
          </button>
          <button *ngIf="filterSearchEnthincitiesList?.length === 0 && !isLoading" ngbDropdownItem>
            {{'updateinfo.ethnicity_no_records_found'|translate}}
          </button>
          <button ngbDropdownItem *ngFor="let list of filterSearchEnthincitiesList"
                  (click)="SetEnthincitiesList(list.ethnicities)" class="text-capitalize">

            {{list.ethnicities | lowercase}}

          </button>



        </div>

      </div>
    </div>
    <div class="d-flex flex-wrap select-list" *ngIf="Updatepersonalinfo.ETHNICITY || Updatepersonalinfo.ETHNICITY2">
      <div *ngIf="Updatepersonalinfo.ETHNICITY" class="select-item mb-3">
        <span id="race1">{{Updatepersonalinfo.ETHNICITY}}</span>
        <a (click)="RemoveEthnicitydata('ethnicity')" class="text-dark">{{'button.delete'|translate}}</a>
      </div>
      <div *ngIf="Updatepersonalinfo.ETHNICITY2" class="select-item mb-3">
        <span id="race2">{{Updatepersonalinfo.ETHNICITY2}}</span>
        <a (click)="RemoveEthnicitydata('ethnicity2')" class="text-dark">{{'button.delete'|translate}}</a>
      </div>

    </div>
  </div>

  <div class="col-md-6 col-lg-6 pb-2">
    <div class="form-group mb-2 border-bottom ">
      <label class="form-label padding-left fw-bold"> {{'updateinfo.races'|translate}}</label>


      <div class="dropdown input-icon search" ngbDropdown style="flex: 2;" #racesDrop="ngbDropdown">
        <input placeholder="{{'updateinfo.races_search'|translate}}" class="form-control text-left text-capitalize border-0" type="text"
               ngbDropdownAnchor (focus)="racesDrop.open()" id="searchracedropdown" aria-haspopup="true" aria-expanded="false" [(ngModel)]="RacesSearch"
               (input)="SearchRacesList($event.target)">

        <div ngbDropdownMenu class="custom-menu" aria-labelledby="searchracedropdown" [ngClass]="{'d-none': dNoneRaces}">

          <button ngbDropdownItem *ngIf="isLoading">
            {{'updateinfo.races_loading'|translate}}
          </button>
          <button ngbDropdownItem *ngIf="!filterSearchRacesList && !isLoading">
            {{'updateinfo.races_search'|translate}}
          </button>
          <button *ngIf="filterSearchRacesList?.length === 0 && !isLoading" ngbDropdownItem>
            {{'updateinfo.races_no_records_found'|translate}}
          </button>
          <button ngbDropdownItem ngbDropdownItem *ngFor="let items of filterSearchRacesList"
                  (click)="SetRacesList(items.race)">

            {{items.race}}
          </button>
        </div>

      </div>
    </div>
    <div class="d-flex flex-wrap select-list " *ngIf="race1 || race2 || race3">
      <div *ngIf="race1" class="select-item mb-3">
        <span id="race1">{{race1}}</span>
        <a (click)="RemoveRacedata('race1')" class="text-dark">{{'button.delete'|translate}}</a>
      </div>
      <div *ngIf="race2" class="select-item mb-3">
        <span id="race2">{{race2}}</span>
        <a (click)="RemoveRacedata('race2')" class="text-dark">{{'button.delete'|translate}}</a>
      </div>
      <div *ngIf="race3" class="select-item mb-3">
        <span id="race2">{{race3}}</span>
        <a (click)="RemoveRacedata('race3')" class="text-dark">{{'button.delete'|translate}}</a>
      </div>

    </div>
  </div>
  -->
          <!-- moved pharmacy code to medication
  <div class="col-md-12 col-lg-6 pb-2">

    <div class="form-group mb-2 border-bottom search-pharm">
      <label class="form-label padding-left fw-bold"> {{'updateinfo.pharmacy'|translate}}</label>
      <div class="dropdown input-icon search" ngbDropdown #pharmacyDrop="ngbDropdown">
        <input placeholder="{{'updateinfo.pharmacy_search'|translate}}" class="form-control text-left border-0 " type="text"
               ngbDropdownAnchor (focus)="pharmacyDrop.open()" id="searchpharmacydropdown" aria-haspopup="true" aria-expanded="false"
               [(ngModel)]="pharmaciesSearch"
               (input)="ValidateAddress($event.target,'pharmacy')" (keyup)="SearchPharmacyList($event)">

        <div ngbDropdownMenu class="custom-menu" aria-labelledby="searchpharmacydropdown" [ngClass]="{'d-none': dNonePharmacy}">

          <button ngbDropdownItem *ngIf="isLoading">
            {{'updateinfo.pharmacy_loading'|translate}}
          </button>
          <button ngbDropdownItem *ngIf="isShowplaceholder">
            {{'updateinfo.pharmacy_search'|translate}}
          </button>
          <button *ngIf="filterSearchPharmaciesList?.length === 0 && !isLoading" ngbDropdownItem>
            {{'updateinfo.pharmacy_no_records_found'|translate}}
          </button>
          <button ngbDropdownItem *ngFor="let pharmacy of filterSearchPharmaciesList"
                  (click)="SetPharmaciesList(pharmacy)">

            <h6 class="mb-1 font-weight-bold text-capitalize">{{pharmacy.pharmacyName | lowercase}}</h6>
            <span class="text-capitalize">{{pharmacy.pharmacyAddress | lowercase}}</span> <br>
            <span class="text-capitalize">{{pharmacy.pharmacyCity | lowercase}}, {{pharmacy.pharmacyState}} {{pharmacy.pharmacyZip.substring(0, 5)}}</span> <br>
            <span>{{pharmacy.pharmacyPhone}}</span>

          </button>



        </div>
      </div>


    </div>
    <div class="d-flex flex-wrap select-list text-capitalize">
      <div *ngIf="Getpharmacies[0]" [triggers]="'mouseenter:mouseleave'" [placement]="'auto'" [autoClose]="true" [ngbPopover]="p1" class="select-item mb-3" style="width: 100%;align-items: flex-start !important;">
        <span id="race1" style="width:80%"><strong>{{Getpharmacies[0].PHARMACY_NAME | lowercase}}</strong><br>{{Getpharmacies[0].PHARMACY_ADDRESS.trim() | titlecase}}, {{Getpharmacies[0].PHARMACY_STATE | uppercase}} {{Getpharmacies[0].PHARMACY_ZIP.substring(0, 5) | titlecase}}<br>{{Getpharmacies[0].PHARMACY_PHONE}}</span>
        <a (click)="RemovePharmacyData('0')" class="text-dark">{{'button.delete'|translate}}</a>
        <ng-template #p1>
          <div class="p-2">
            <b>{{Getpharmacies[0].PHARMACY_NAME | titlecase}}</b><br>
            <p>{{Getpharmacies[0].PHARMACY_ADDRESS.trim() | titlecase}}, {{Getpharmacies[0].PHARMACY_STATE | uppercase}} {{Getpharmacies[0].PHARMACY_ZIP.substring(0, 5) | titlecase}}<br>{{Getpharmacies[0].PHARMACY_PHONE}}</p>
          </div>
        </ng-template>
      </div>
      <div *ngIf="Getpharmacies[1]" [triggers]="'mouseenter:mouseleave'" [placement]="'auto'" [autoClose]="true" [ngbPopover]="p2" class="select-item mb-3" style="width: 100%;align-items: flex-start !important;">
        <span id="race2" style="width:80%"><strong>{{Getpharmacies[1].PHARMACY_NAME | lowercase}}</strong><br>{{Getpharmacies[1].PHARMACY_ADDRESS.trim() | titlecase}}, {{Getpharmacies[1].PHARMACY_STATE | uppercase}} {{Getpharmacies[1].PHARMACY_ZIP.substring(0, 5) | titlecase}}<br>{{Getpharmacies[1].PHARMACY_PHONE}}</span>
        <a (click)="RemovePharmacyData('1')" class="text-dark">{{'button.delete'|translate}}</a>
        <ng-template #p2>
          <div class="p-2">
            <b>{{Getpharmacies[1].PHARMACY_NAME | titlecase}}</b><br>
            <p>{{Getpharmacies[1].PHARMACY_ADDRESS.trim() | titlecase}}, {{Getpharmacies[1].PHARMACY_STATE | uppercase}} {{Getpharmacies[1].PHARMACY_ZIP.substring(0, 5) | titlecase}}<br>{{Getpharmacies[1].PHARMACY_PHONE}}</p>
          </div>
        </ng-template>
      </div>
      <div *ngIf="Getpharmacies[2]" [triggers]="'mouseenter:mouseleave'" [placement]="'auto'" [autoClose]="true" [ngbPopover]="p3" class="select-item mb-3" style="width: 100%;align-items: flex-start !important;">
        <span id="race2" style="width:80%"><strong>{{Getpharmacies[2].PHARMACY_NAME | lowercase}}</strong><br>{{Getpharmacies[2].PHARMACY_ADDRESS.trim() | titlecase}}, {{Getpharmacies[2].PHARMACY_STATE | uppercase}} {{Getpharmacies[2].PHARMACY_ZIP.substring(0, 5) | titlecase}}<br>{{Getpharmacies[2].PHARMACY_PHONE}}</span>
        <a (click)="RemovePharmacyData('2')" class="text-dark">{{'button.delete'|translate}}</a>
        <ng-template #p3>
          <div class="p-2">
            <b>{{Getpharmacies[2].PHARMACY_NAME | titlecase}}</b><br>
            <p>{{Getpharmacies[2].PHARMACY_ADDRESS.trim() | titlecase}}, {{Getpharmacies[2].PHARMACY_STATE | uppercase}} {{Getpharmacies[2].PHARMACY_ZIP.substring(0, 5) | titlecase}}<br>{{Getpharmacies[2].PHARMACY_PHONE}}</p>
          </div>
        </ng-template>
      </div>
    </div>



  </div>
  -->

        </div>
          </div>
        </div>
      </div>
      
      <footer class="p-3">
        <div class="container p-0">
          <div class="d-flex justify-content-between align-items-center">
            <button class="btn btn-primary v-hidden pointer-none" type="button">{{'button.back'|translate}}</button>
            <!-- <a class="btn btn-outline-primary" type="button" href="Screen-1.html">Back</a> -->
            <!--<p class="mb-0">({{pageNum}} {{'generic_text.of'|translate}} {{totalPages}})</p>-->
            <button class="btn btn-primary" type="button" (click)="UpdatePatientInfo()">{{'button.next'|translate}}</button>
          </div>
        </div>
      </footer>
